<template>
  <v-dialog scrollable max-width="300px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <div class="my-2">
        <v-icon v-on="on" disabled>edit</v-icon>
      </div>
    </template>
    <v-card>
      <v-card-title>
        <h4>Actualizar monto</h4>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-text-field
            type="number"
            label="Nuevo monto"
            v-model="nuevoMonto"
            autofocus
          />
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="volver">Volver</v-btn>
        <v-btn color="info" @click="confirmar">Actualizar</v-btn>
      </v-card-actions>
      <span class="red--text">{{ errorMessage }}</span>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";
import axios from "axios";
import numeral from "numeral";

export default Vue.extend({
  props: ["id", "monto"],
  data() {
    return {
      loading: false,
      errorMessage: "",
      showDialog: false,
      nuevoMonto: "",
      rules: {
        required: (value) => !!value || "Requerido.",
        counter: (value) => value.length <= 1000 || "Maximo 100 caracteres",
      },
      validForm: false,
    };
  },
  mounted() {
    this.nuevoMonto = this.monto;
  },
  methods: {
    buscar(e) {
      if (this.busqueda === e.target.value.toUpperCase()) {
        return;
      }
      this.busqueda = e.target.value.toUpperCase();

      if (this.buscarTimer) {
        clearTimeout(this.buscarTimer);
      }

      this.buscarTimer = setTimeout(() => {
        if (this.busqueda && this.busqueda.length > 2) {
          this.filtrado = this.pendientes.filter((fila) => {
            return fila.nombreBeneficiario
              .toUpperCase()
              .includes(this.busqueda);
          });
        } else {
          this.filtrado = this.pendientes;
        }

        this.buscarTimer = null;
      }, 500);
    },
    close() {
      this.$refs.form.reset();
      this.showDialog = false;
    },
    volver() {
      this.showDialog = false;
    },
    confirmar() {
      axios
        .post(`/pagoDetalle/${this.id}/actualizarMonto/${this.nuevoMonto}`)
        .then((response) => {
          console.log(response);
          this.$emit("nuevoMonto", {
            id: this.id,
            nuevoMonto: this.nuevoMonto,
          });
          this.close();
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.nuevoMonto = this.monto;

          if (err && err.response && err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });
    },
  },
  filters: {
    numberFormat(value) {
      if (value) {
        return numeral(value).format("#,##0"); // displaying other groupings/separators is possible, look at the docs
      }
    },
  },
});
</script>